export const PAYMENT_STATUSES = [
    { label: 'Succeeded', name: 'Succeeded', value: 'succeeded' },
    { label: 'Pending', name: 'Pending', value: 'pending' },
    { label: 'Failed', name: 'Failed', value: 'failed' }
]